export default {
  getDocumentDetails(documentName) {
    return DocumentDescription[documentName];
  }
}

export const Documents = {
  MANDATE_DOCUMENT: "MANDATE_DOCUMENT",
  MERGED_DOCUMENT: "MERGED_DOCUMENT",
  NACH: "NACH",
  SIGNED_DOCUMENT: "SIGNED_DOCUMENT",
  DELIVERY_ADVICE_DOCUMENT: "DELIVERY_ADVICE_DOCUMENT"
};

export const DocumentStatus = {
  DEFAULT: "Default",
  NOT_VERIFIED: "NOT_VERIFIED",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
  PASSWORD_PENDING: "PASSWORD_PENDING"
};

export const DocumentStatusValueToDocumentStatus = {
  Default: "DEFAULT",
  NOT_VERIFIED: "",
  VERIFIED: "",
  REJECTED: "",
  "Password Pending": "PASSWORD_PENDING"
};

export const DocumentDescription = {
  GST_COPY: {
    name: "GST_COPY",
    directory: "GST_COPY",
    description: "GST Copy"
  },

  CANCELLED_CHEQUE: {
    name: "CANCELLED_CHEQUE",
    directory: "CANCELLED_CHEQUE",
    description: "Cancelled Cheque"
  },

  ALTERNATE_PAN: {
    name: "ALTERNATE_PAN",
    directory: "ALTERNATE_PAN",
    description: "Alternate Pan Card Image"
  },

  AADHAAR_FRONT_IMAGE: {
    name: "AADHAAR_FRONT_IMAGE",
    directory: "aadhaarImage",
    description: "Front Image of Aadhaar Card"
  },

  AADHAAR_BACK_IMAGE: {
    name: "AADHAAR_BACK_IMAGE",
    directory: "aadhaarImage",
    description: "Back Image of Aadhaar Card"
  },

  PRODUCT_INVOICE: {
    name: "PRODUCT_INVOICE",
    directory: "invoice",
    description: "Product Invoice Copy"
  },

  BANK_STATEMENT_FRONT_IMAGE: {
    name: "BANK_STATEMENT_FRONT_IMAGE",
    directory: "bankStatement",
    description: "Bank Statements Front Page"
  },

  BANK_STATEMENT: {
    name: "BANK_STATEMENT",
    directory: "bankStatement",
    description: "Bank Statements"
  },

  KYC_OSV_ADDRESS_PROOF_FRONT: {
    name: "KYC_OSV_ADDRESS_PROOF_FRONT",
    directory: "kyc",
    description: "KYC Address Front Page"
  },

  KYC_OSV_ADDRESS_PROOF_BACK: {
    name: "KYC_OSV_ADDRESS_PROOF_BACK",
    directory: "kyc",
    description: "KYC Address Back Page"
  },

  KYC_OSV_ID_PROOF: {
    name: "KYC_OSV_ID_PROOF",
    directory: "kyc",
    description: "KYC Id Proof"
  },

  ADDRESS_PROOF: {
    name: "ADDRESS_PROOF",
    directory: "kyc",
    description: "Address proof"
  },

  ADDRESS_PROOF_FRONT: {
    name: "ADDRESS_PROOF",
    keyName: "ADDRESS_PROOF_FRONT",
    directory: "kyc",
    description: "Address proof"
  },

  ADDRESS_PROOF_BACK: {
    name: "ADDRESS_PROOF",
    keyName: "ADDRESS_PROOF_BACK",
    directory: "kyc",
    description: "Address proof"
  },
};


